import React, { useEffect, useState } from 'react'
import ModalBasic from '../../components/infrastructure/Modals/ModalBasic'
import { useDispatch } from 'react-redux'
import { fetchContacts } from '../../app/reducers/Contacts/contactsSlice';

const ViewQuarterlyBrokerageModal = ({
    showQuarterlyBrokerageModal,
    setShowQuarterlyBrokerageModal,
    payloadData
}) => {
    const[customerData,setCustomerData] = useState(null)
    const dispatch = useDispatch();
    const fetchData = async (obj)=>{
        try {
            const resp = await dispatch(fetchContacts({ search : obj.name,contact_type:obj.contact_type }))
            // console.log('resp',resp)
            setCustomerData(resp?.payload?.contacts[0])
        } catch (error) {
            console.log('Error',error)
        }
    }

    useEffect(()=>{
        if(payloadData){
            fetchData(payloadData)
        }
    },[payloadData])
  return (
    <ModalBasic
        modalOpen={showQuarterlyBrokerageModal}
        setModalOpen={setShowQuarterlyBrokerageModal}
        title={'Quarterly Brokerage Detail'}
    >
        <div className='p-4'>
            <div className='flex flex-col gap-2'>
                <h1 className='font-semibold text-black'>Buyer Name : <span className='text-indigo-500 font-normal'>{customerData?.company_name}</span></h1>
                <p className='font-semibold text-black'>Quarterly Brokerage Mode : <span className='text-indigo-500 font-normal'>{customerData?.cf_quarterly_brokerage_mode}</span></p>
                {/* <p className='font-semibold text-black'>Quarterly Brokerage Manufacturer : <span className='text-indigo-500 font-normal'>{customerData?.cf_quality_manufacturer}</span></p> */}
            </div>
        </div>
      
    </ModalBasic>
  )
}

export default ViewQuarterlyBrokerageModal
